import { cloudbase } from '@/utils/cloudbase'
import { message } from 'antd'
import { history } from 'umi'

const pendings = new Map<string, Promise<any>>()

export const request = async (action: string, params?: any) => {
    const key = action
    if(pendings.has(key)) {
        return pendings.get(key)
    }
    const promise = (async () => {
        try {
            const res = await cloudbase.callFunction({
                name: 'fiance',
                data: {
                    action,
                    data: {
                        authorization: localStorage.getItem("authorization"),
                        ...(params || {})
                    }
                }
            })
            const result = res.result
            if(!result.success) {
                message.error(result.message)
                if(result.code === 401) {
                    history.push('/user/login')    
                }
            }
            return result
        } finally {
            setTimeout(() => pendings.delete(key), 1000);
        }
    })();

    pendings.set(key, promise);
    return promise
}
